/**
 * Product Form Handler
 * Handles variant selection and form submission
 */

class ProductForm extends HTMLElement {
  constructor() {
    super();
    
    this.form = this.querySelector('form');
    this.variantInputs = this.querySelectorAll('input[type="radio"][name^="options"]');
    this.submitButton = this.querySelector('button[type="submit"]');
    
    this.init();
  }

  init() {
    if (this.variantInputs.length > 0) {
      this.variantInputs.forEach(input => {
        input.addEventListener('change', this.onVariantChange.bind(this));
      });
    }

    if (this.form) {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updatePrice();
    this.updateButton();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map(fieldset => {
      return Array.from(fieldset.querySelectorAll('input')).find(radio => radio.checked).value;
    });
  }

  updateMasterId() {
    const variant = this.getVariant();
    if (variant) {
      this.querySelector('input[name="id"]').value = variant.id;
    }
  }

  updatePrice() {
    const variant = this.getVariant();
    if (!variant) return;

    const priceElement = document.querySelector('.product-template__price');
    if (priceElement && variant.price) {
      const formattedPrice = window.formatMoney(variant.price);
      priceElement.querySelector('.price').textContent = formattedPrice;
    }
  }

  updateButton() {
    const variant = this.getVariant();
    if (!variant) return;

    const text = variant.available
      ? window.variantStrings.addToCart
      : window.variantStrings.soldOut;
    
    this.submitButton.textContent = text;
    this.submitButton.disabled = !variant.available;
  }

  getVariant() {
    // This would typically use the product JSON to find the matching variant
    // For now, return a placeholder
    return null;
  }

  async onSubmit(event) {
    event.preventDefault();

    const formData = new FormData(this.form);
    const config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: formData
    };

    try {
      const response = await fetch(window.routes.cart_add_url, config);
      
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      // Update cart and redirect or show notification
      if (window.chaoticTheme) {
        await window.chaoticTheme.updateCartCount();
      }

      // Redirect to cart or show success message
      window.location.href = window.routes.cart_url;
    } catch (error) {
      console.error('Error adding to cart:', error);
    }
  }
}

customElements.define('product-form', ProductForm);
